import {getQtCatName} from "../helpers/sqftQuotesHelper";

export class FeatureObjectDTO {
  constructor(id, partId, featureId, quantity = 1) {
    this.id = id;
    this.qtCatName = getQtCatName();
    this.partId = partId;
    this.featureId = featureId;
    this.quantity = quantity;
  }

  addBumpoutArea(area) {
    this.area = area;
  }
}
